import { createContext } from 'react';

const StickyManagerContext = /*#__PURE__*/createContext(undefined);

export { StickyManagerContext };
